module.exports = __webpack_public_path__ + "img/pic_default.9a81e80d.png";